
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PatientEmployment',
  props: ['patient'],
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        title: 'Status',
        align: 'start',
        sortable: false,
        key: 'employmentStatus',
      },
      { title: 'Employer', key: 'employer' },
      { title: 'Occupation', key: 'occupation' },
      { title: 'Contact', key: 'contact' },
      { title: 'Contact Number', key: 'contactNumber' },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    patientEmployments: [],
    editedIndex: -1,
    editedItem: {
      employmentStatus: '',
      employer: '',
      occupation: '',
      contact: '',
      contactNumber: ''
    },
    defaultItem: {
      employmentStatus: '',
      employer: '',
      occupation: '',
      contact: '',
      contactNumber: ''
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New' : 'Edit'
      },
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    if (!this.patient){
      return
    }
    this.initialize()
  },
  methods: {
    initialize () {
      this.patientEmployments = [
        {
          employmentStatus: 'Active',
          employer: 'Jamzers Pty Ltd',
          occupation: 'Doctor',
          contact: 'Piper',
          contactNumber: 'piper@jamzers.com'
        },
        {
          employmentStatus: 'Previous',
          employer: 'UCPB',
          occupation: 'Trainee',
          contact: 'hr',
          contactNumber: 'ucpb@someucpb.com'
        }
      ]
    },

    editItem (item) {
      this.editedIndex = this.patientEmployments.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.patientEmployments.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.patientEmployments.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.patientEmployments[this.editedIndex], this.editedItem)
      } else {
        this.patientEmployments.push(this.editedItem)
      }
      this.close()
    },
  },
})
